// @ts-nocheck
import styled from 'styled-components';

export const InsightsItemsSelectorStyled = styled.nav`
  display: flex;
  gap: 16px;
  height: fit-content;
  align-items: center;
  margin-top: 16px;
`;
